import {
  SoloActionType,
  SAVE_SOLO,
  SELECTED_SOLO,
  SOLO_SAVE_SUCCESS,
  SOLO_SERVICE,
  NODES_CONNECTABLE,
  MODAL_SELECTED_VALUE,
  SELECTED_JOURNEY,
  SOURCE_CONNECTED,
  GO_BACK,
  EVENTS_NODE_CONNECTION,
} from "./types";

const initialState = {
  isSaved: false,
  soloSaved: false,
  selectedService: null,
  connectable: true,
  goBackSolo: true,
  ModalSelectedValues: null,
  selectedJourneyInBpmn: null,
  sourceConnection: true,
  eventNodeServiceConnections: null,
};

export function SoloReducer(
  state = initialState,
  action: SoloActionType
) {
  switch (action.type) {
    case SAVE_SOLO:
      return { ...state, isSaved: action.data };
    case SELECTED_SOLO:
      return { ...state, selectedSolo: action.data }
    case SOLO_SAVE_SUCCESS:
      return { ...state, soloSaved: action.data }
    case SOLO_SERVICE:
      return { ...state, selectedService: action.data }
    case NODES_CONNECTABLE:
      return { ...state, connectable: action.data }
    case MODAL_SELECTED_VALUE:
      return { ...state, ModalSelectedValues: action.data }
    case SELECTED_JOURNEY:
      return { ...state, selectedJourneyInBpmn: action.data }
    case SOURCE_CONNECTED:
      return { ...state, sourceConnection: action.data }
    case GO_BACK:
      return { ...state, goBackSolo: action.data }
    case EVENTS_NODE_CONNECTION: 
      return { ...state, eventNodeServiceConnections: action.data}
    default:
      return state;
  }
}
